import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';

import { connect } from 'react-redux';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import styles from './styles';

import { openLoginDialog, closeLoginDialog } from '../../modules/login';
import {
  closeForgotPasswordDialog,
  openForgotPasswordDialog
} from '../../modules/forgotpassword';

/**
 *  Login Block Component
 */
class LoginBlock extends Component {
  _handleLogin = () => {
    this.props.openLoginDialog();
  };

  _handleForgotPassword = () => {
    this.props.openForgotPasswordDialog();
  };

  render() {
    const { classes } = this.props;

    return (
      <Grid container className={classes.root} spacing={0}>
        <Paper className={classes.paper} style={{}}>
          {/* FFC Logo */}
          <div className={classes.logoCircle}>
            <img
              src={require('../../images/FFC_Logo_Circle_Navy.png')}
              style={{ width: 150, height: 150 }}
            />
          </div>
          <h2 className={classes.title}>Grow App</h2>
          {/* <h3 className={classes.subtitle}>In Partnership With</h3> */}

          {/* <div className={classes.logoCircle}>
            <img
              src={require('../../images/foodland.png')}
              style={{ height: 110 }}
            />
          </div> */}
         
          <div style={{ height: 50 }} />
          <Button
            variant="raised"
            color="primary"
            className={classes.loginButton}
            onClick={this._handleLogin}>
            Login
          </Button>

          <span
            onClick={this._handleForgotPassword}
            className={classes.forgotPassword}>
            Forgot Password?
          </span>
        </Paper>
      </Grid>
    );
  }
}

LoginBlock = withStyles(styles)(LoginBlock);

function mapStateToProps(state, ownProps) {
  return {
    token: state.user.token
  };
}

function mapDispatchToProps(dispatch) {
  return {
    openLoginDialog: () => dispatch(openLoginDialog()),
    closeLoginDialog: () => dispatch(closeLoginDialog()),
    openForgotPasswordDialog: () => dispatch(openForgotPasswordDialog()),
    closeForgotPasswordDialog: () => dispatch(closeForgotPasswordDialog())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginBlock);



// WEBPACK FOOTER //
// ./src/components/LoginBlock/index.js